import { createStore, applyMiddleware, compose } from 'redux';

import { routerMiddleware } from 'react-router-redux';
import dispatchLocation from './dispatch_location';
import thunk from 'redux-thunk';
import rootReducer from './root_reducer.js';
// import { logger } from 'redux-logger';

//TODO Confirm this doens't need code splitting
import hashHistory from './history';

export default function configureStore(initialState) {
    const middlewares = [dispatchLocation, thunk];

    if (process.env.NODE_ENV !== 'test') {
        const historyMiddleWare = routerMiddleware(hashHistory);
        middlewares.push(historyMiddleWare);
    }

    if (process.env.NODE_ENV === 'development') {
        // middlewares.push(logger);
    }

    const store = createStore(
        rootReducer,
        initialState,
        compose(
            applyMiddleware(...middlewares),
            // https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd
            process.env.NODE_ENV !== 'production' && global.devToolsExtension
                ? global.devToolsExtension()
                : f => f
        )
    );

    return store;
}



// WEBPACK FOOTER //
// ./src/configure_store.js